import { GenericDrawer, ListCard, Text } from '@capsicum/common-web';
import { useNCWInsufficientChzDrawer } from '@capsicum/features/nc-wallet/shared';
import { type NCWInsufficientChzDrawerProps } from '@capsicum/socios-core';
import { NCWInsufficientChzStyled as S } from '@capsicum/socios-core-web';

export const NCWInsufficientChzDrawer = ({
	onPrimaryButtonActivate,
	onSecondaryButtonActivate
}: NCWInsufficientChzDrawerProps) => {
	const { intlText, zeroAltBalance, zeroDefaultBalance } = useNCWInsufficientChzDrawer();

	return (
		<GenericDrawer
			buttonText={intlText.primaryButtonText}
			description={intlText.description}
			isButtonFullWidth={false}
			isButtonOnRow={false}
			secondaryActionButtonText={intlText.secondaryButtonText}
			testID="ncw-send-insufficientChz-drawer"
			title={intlText.title}
			onButtonPress={onPrimaryButtonActivate}
			onSecondaryActionOnButtonPress={onSecondaryButtonActivate}
		>
			<S.Children>
				<S.BalanceCard>
					<S.CardContent>
						<Text color="main.enabled" variant="text5">
							{intlText.yourBalance}
						</Text>
					</S.CardContent>
					<ListCard.End>
						<S.ZeroAmounts>
							<Text color="destructive.enabled" variant="text5">
								{zeroDefaultBalance}
							</Text>
							<Text color="destructive.enabled" variant="text5">
								{zeroAltBalance}
							</Text>
						</S.ZeroAmounts>
					</ListCard.End>
				</S.BalanceCard>
			</S.Children>
		</GenericDrawer>
	);
};
